import {Row, Col, Card, Button, Input, Form, Divider, Select, Typography, Spin} from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router";
import apiPath from "../../constants/apiPath";
import SingleImageUpload from "../../components/SingleImageUpload";
import { Link } from "react-router-dom";
import TextArea from "antd/lib/input/TextArea";
import { CD_TYPE_SELECTION, CITY_SELECTION_TYPE, PSLA_INPUT_TYPE, PSLA_REQUIRED_SELECTION } from "../../constants/conts";
const { Option } = Select;

function Add() {

    const sectionName   =   "Brand";
    const routeName     =   "brand";
    
    const api = {
        addEdit             :  apiPath.addEditBrand,
        category            :  apiPath.commonCategory,
        tag                 :  apiPath.commonTag,
        cluster             :  apiPath.commonCluster,
        city                :  apiPath.commonCity,
        generateNumber      :  apiPath.generateNumber,
        commonBrandSearch   :  apiPath.commonBrandSearch,
        editBrand           :  apiPath.editBrand,
    }
    
    const location                          =   useLocation();
    const [form]                            =   Form.useForm();
    const FileType                          =   ["image/png", "image/jpg", "image/jpeg", "image/avif", "image/webp", "image/svg", "image/gif"]
    const { request }                       =   useRequest()
    const [loading, setLoading]             =   useState(false)
    const navigate                          =   useNavigate();
    const [image, setImage]                 =   useState([]);
    const [categoryList, setCategoryList]   =   useState([]);
    const [tagList, setTagList]             =   useState([]);
    const [cityList, setCityList]           =   useState([]);
    const [clusterList, setClusterList]     =   useState([]);
    const [commonPSLA, setCommonPSLA]       =   useState([{ psla_label: '', psla_type: 'Text' }]);
    const [citySelection, setCitySelection] =   useState('All Cities');
    const [brandSearchList, setBrandSearchList]         =   useState([]);
    const [brandSearchLoading, setBrandSearchLoading]   =   useState(false);
    const [brandSelectLoading, setBrandSelectLoading]   =   useState(false);
    const [selectedBaseBrandId, setSelectedBaseBrandId] =   useState(null);
    const debounceTimer                                 =   React.useRef(null);

    const fetchBrandNumber = () => {
        try {
            request({
                url: api.generateNumber,
                method: 'GET',
                onSuccess: (response) => {
                    form.setFieldsValue({ sp_code: response.data }); 
                },
                onError: (error) => {
                    console.log(error);
                    ShowToast(error, Severty.ERROR);
                }
            })
        } catch (error) {
            console.error('Error generating brand number:', error);
        }
    }

    const handleCityChange = (value) => {
        setCitySelection(value);
        form.resetFields(['city_id', 'multiple_cities']);
    };

    const searchBrands = (searchValue) => {
        if (!searchValue || searchValue.trim() === '') {
            setBrandSearchList([]);
            return;
        }

        setBrandSearchLoading(true);
        request({
            url: api.commonBrandSearch,
            method: 'POST',
            data: {
                query: searchValue.trim(),
                include_all: true
            },
            onSuccess: (response) => {
                const brands = response.data?.data || [];
                setBrandSearchList(brands);
                setBrandSearchLoading(false);
            },
            onError: (error) => {
                console.log(error);
                setBrandSearchList([]);
                setBrandSearchLoading(false);
            }
        })
    };

    const handleBrandSearch = (value) => {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }
        
        debounceTimer.current = setTimeout(() => {
            searchBrands(value);
        }, 800);
    };

    const handleSelectBrand = (brandId) => {
        setBrandSelectLoading(true);
        request({
            url: api.editBrand + "/" + brandId,
            method: 'GET',
            onSuccess: (response) => {
                const brandData = response?.data || {};
                const { sp_code, ...brandDataWithoutCode } = brandData;
                
                form.setFieldsValue(brandDataWithoutCode);
                
                if (brandData.logo) {
                    setImage([{ url: brandData.logo }]);
                }
                
                setCitySelection(brandData.city_selection);
                setSelectedBaseBrandId(brandId);
                
                if (brandData.psl_list && Array.isArray(brandData.psl_list)) {
                    setCommonPSLA(brandData.psl_list);
                }

                fetchBrandNumber();
                setBrandSearchList([]);
                setBrandSelectLoading(false);
                ShowToast('Brand data loaded successfully', Severty.SUCCESS);
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
                setBrandSelectLoading(false);
            }
        })
    };

    const handleClearBrandSearch = () => {
        form.resetFields();
        setBrandSearchList([]);
        setImage([]);
        setCitySelection('All Cities');
        setCommonPSLA([{ psla_label: '', psla_type: 'Text' }]);
        setSelectedBaseBrandId(null);
        fetchBrandNumber();
    };

    // PSLA Logic Start
    const handleCommonPSLAChange = (index, field, value) => {
        const newCommonPSLA = [...commonPSLA];
        newCommonPSLA[index][field] = value;
        setCommonPSLA(newCommonPSLA);
    };

    const addCommonPSLA = () => {
        setCommonPSLA([...commonPSLA, { psla_label: '', psla_type: 'Text' }]);
    };

    const removeCommonPSLA = (index) => {
        const newCommonPSLA = commonPSLA.filter((_, i) => i !== index);
        setCommonPSLA(newCommonPSLA);
    };
    // PSLA Logic End

    const handleImage = (data) => {
        setImage(data);
        form.setFieldValue('logo', data);
    }

    const getCategoryList = () => {
        request({
        url: api.category,
        method: 'GET',
        onSuccess: (response) => {
            setCategoryList(response.data.data);
        },
        onError: (error) => {
            console.log(error)
            ShowToast(error, Severty.ERROR)
        }
        })
    };

    const getClusterList = () => {
        request({
            url: api.cluster,
            method: 'GET',
            onSuccess: (response) => {
                setClusterList(response.data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    };

    const getCityList = () => {
        request({
            url: api.city,
            method: 'GET',
            onSuccess: (response) => {
                setCityList(response.data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    };

    const getTagList = () => {
        request({
            url: api.tag,
            method: 'GET',
            onSuccess: (response) => {
                setTagList(response.data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    };

    const onCreate = (values) => {

        let logo = null;

        if (typeof image === 'string') {
            logo = image;
        }
        else if (Array.isArray(image) && image.length > 0) {
            logo = image[0].url;
        }

        let payload = {
            ...values,
            long_description    :   (values.long_description != "" || values.long_description) ? values.long_description : null,
            multiple_cities     :   citySelection == 'Multiple Cities' ? values.multiple_cities : null,
            logo                :   logo,
            city_id             :   citySelection == 'Single City' ? values.city_id : null,
            base_brand_id       :   selectedBaseBrandId,
        };
        
        setLoading(true)
        request({
            url: api.addEdit,
            method: 'POST',
            data: payload,
            onSuccess: (data) => {
                setLoading(false)
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS)
                    setSelectedBaseBrandId(null);
                    navigate(`/${routeName}`);
                } else {
                    ShowToast(data.message, Severty.ERROR)
                }
            },
            onError: (error) => {
                ShowToast(error?.response?.data?.message || "Something went wrong, Please try again later", Severty.ERROR)
                setLoading(false)
            },
        })
    };
    
    useEffect(() => {
        getCategoryList();
        getTagList();
        getClusterList();
        getCityList();
        fetchBrandNumber();

        return () => {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }
        };
    }, [])
      
    return (
        <Card title={"Add New " + sectionName}>
            <Spin spinning={brandSelectLoading} tip="Loading brand data...">
                <Form className="edit-page-wrap" form={form} onFinish={onCreate} autoComplete="off" layout="verticle" name="blog_form">
                
                <Row gutter={[24, 0]}>

                    <Col span={24} xs={24}>
                        <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
                           Select an existing brand to display its data here. It will always be treated as a new brand, and the data is provided only to reduce manual data entry effort.
                       </Typography.Text>
                    </Col>

                    <Col span={24} xs={24} sm={24} md={8}>
                        <Form.Item
                            label="Search Existing Brand to Copy Data"
                            name="brand_search"
                        >
                            <Select
                                showSearch
                                placeholder="Search brand by name..."
                                notFoundContent={brandSearchLoading ? 'Loading...' : 'No brands found'}
                                filterOption={false}
                                onSearch={handleBrandSearch}
                                onSelect={handleSelectBrand}
                                onClear={handleClearBrandSearch}
                                loading={brandSearchLoading}
                                allowClear
                            >
                                {brandSearchList?.map((brand) => (
                                    <Option key={brand._id} value={brand._id}>
                                        <span className="cap">{brand.name}</span>
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    
                    <Col span={24} xs={24} sm={24} md={24}>
                        <Divider style={{ margin: '16px 0' }} />
                    </Col>

                    <Col span={24} xs={12} sm={12} md={8}>
                        <Form.Item
                            label={`${sectionName} Name`}
                            name="name"
                            normalize={value => value.trimStart()}
                            rules={[
                                { required: true, message: "Please Enter the brand name!" },
                                { max: 255, message: "Brand name should not contain more then 255 characters!" },
                                { min: 2, message: "Brand name should contain at least 2 characters!" }
                            ]}
                        >
                            <Input autoComplete="off" placeholder={`Enter ${sectionName} Name`} />
                        </Form.Item>
                    </Col>

                    <Col span={24} xs={12} sm={12} md={8}>
                        <Form.Item
                            label="Brand Identity Number"
                            name="sp_code"
                        >
                            <Input autoComplete="off" placeholder={`Auto Generated Brand Identity Number`} disabled />
                        </Form.Item>
                    </Col>

                    <Col span={12} xs={12} sm={12} md={8}>
                        <Form.Item className="banner-elt"
                            name="category_id"
                            label="Select Category"
                            rules={[{ required: true, message: 'Missing Category Selection' }]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Category"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option?.children?.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                                }
                            >
                                <Option key="default" value={null}>
                                    ---- Select ----
                                </Option>

                                {categoryList?.map((item, index) => (
                                    <Option key={index} value={item._id}>
                                        <span className="cap">{item.name}</span>
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    
                    <Col span={12} xs={12} sm={12} md={8}>
                        <Form.Item className="banner-elt"
                            name="cluster_id"
                            label="Select Cluster"
                        >
                            <Select
                                showSearch
                                placeholder="Select Cluster"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option?.children?.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                                }
                            >
                                <Option key="default" value={null}>
                                    ---- Select ----
                                </Option>

                                {clusterList?.map((item, index) => (
                                    <Option key={index} value={item._id}>
                                        <span className="cap">{item.name}</span>
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12} xs={12} sm={12} md={8}>
                        <Form.Item className="banner-elt"
                            name="city_selection"
                            label="City Selection Type"
                            rules={[{ required: true, message: 'Missing City Selection Type' }]}
                        >
                            <Select
                                showSearch
                                placeholder="City Selection Type"
                                optionFilterProp="children"
                                onChange={handleCityChange}
                                filterOption={(input, option) =>
                                    option?.children?.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                                }
                            >
                                <Option key="default" value={null}>
                                    ---- Select ----
                                </Option>

                                {CITY_SELECTION_TYPE?.map((item, index) => (
                                    <Option key={index} value={item._id}>
                                        <span className="cap">{item.name}</span>
                                    </Option>
                                ))}
                            </Select>

                        </Form.Item>
                    </Col>

                    <Col span={12} xs={12} sm={12} md={8}>
                        {citySelection == 'Single City' && (
                            <Form.Item className="banner-elt"
                                name="city_id"
                                label="Select City"
                                rules={[{ required: true, message: 'Missing City Selection' }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select City"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option?.children?.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                                    }
                                >
                                    <Option key="default" value={null}>
                                        ---- Select ----
                                    </Option>

                                    {cityList?.map((item, index) => (
                                        <Option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}
                    </Col>

                     <Col span={24} xs={24} sm={24} md={24}>
                        {citySelection == 'Multiple Cities' && (
                            <Form.Item
                                className="banner-elt"
                                label="Select Multiple Cities"
                                name="multiple_cities"
                                rules={[{ required: true, message: 'Missing City Selection' }]}
                            >
                                <Select
                                    mode="multiple"
                                    placeholder="Select Multiple Cities"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option?.children?.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                                    }
                                >
                                    <Option key="default" value={null}>
                                        ---- Select ----
                                    </Option>

                                    {cityList?.map((item, index) => (
                                        <Option key={index} value={item._id}>
                                        <span className="cap">{item.name}</span>
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}
                    </Col>
                    
                    <Col span={24} xs={24} sm={24} md={24}>
                        <Form.Item
                            label="Select Tags (Multiple)"
                            name='tag_id'
                        >
                            <Select
                                mode="multiple"
                                showSearch
                                placeholder="Select Tag"
                                filterOption={(input, option) => (option.label ?? '').toLowerCase().includes(input.toLowerCase())}
                            >
                                <Option key="default" value={null}>
                                    ---- Select ----
                                </Option>

                                {tagList?.map((item) => (
                                    <Option key={item._id} value={item._id} label={item.title}>
                                        <span className="cap">{item.title}</span>
                                    </Option>
                                ))}

                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={24} xs={12} sm={12} md={24}>
                        <Form.Item
                            label="Short Description (Max Limit : 255)"
                            name="short_description"
                            normalize={value => value.trimStart()}
                            rules={[
                                { required: true, message: "Please enter the short description!" },
                                { max: 255, message: "Short description should not contain more then 255 characters!" },
                                { min: 2, message: "Short description should contain at least 2 characters!" }
                            ]}
                        >
                            <Input autoComplete="off" placeholder={`Enter Short Description (Optional)`} />
                        </Form.Item>
                    </Col>

                    <Col span={24} xs={12} sm={12} md={24}>
                        <Form.Item
                            label="Long Description"
                            name="long_description"
                            normalize={value => value.trimStart()}
                            rules={[
                                { min: 5, message: "Long description should contain at least 5 characters!" }
                            ]}
                        >
                            <TextArea rows={7} autoComplete="off" placeholder={`Enter Long Description (Optional)`} />
                        </Form.Item>
                    </Col>

                    <Col span={24} xs={24} sm={24} md={24}>
                        <Form.Item 
                            label={
                                <div>
                                    <span style={{ fontWeight: 600 }}>Brand Logo</span>
                                    <span style={{ fontSize: 14, color: "#888", marginLeft: '5px' }}>
                                        (Accept : png, jpg, jpeg, avif, webp, svg, gif) • Dimension : 150 × 150 px
                                    </span>
                                </div>
                            }
                            valuePropName="value" name="logo" className="mb-1"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please upload a brand logo!',
                                },
                            ]}
                        >
                            <div className="mb-1"></div>

                            <SingleImageUpload initialValue={image} fileType={FileType} imageType={'brand'} btnName={'Logo'} onChange={(data) => handleImage(data)} />

                        </Form.Item>
                    </Col>

                    <Divider orientation="left" orientationMargin={15} className="devider-color">{"Contact Details (CD)"}</Divider>

                    <Col span={24} xs={24} sm={24} md={24} style={{ marginLeft : "-8px" }}>
                        <Form.List name="contact_detail">
                            {(fields, { add, remove }) => (
                                <>
                                    <Row gutter={16}>
                                        {fields.map((field, index) => (
                                            <Col span={24} xs={24} sm={24} md={24}>
                                                <div key={field.key} align="baseline" className="gap-cls" style={{ display: 'flex' }}>
                                                    
                                                    <Col span={20} xs={20} sm={20} md={6}> 
                                                        <Form.Item
                                                            className="qty-cls"
                                                            name={[field.name, 'type']}
                                                            rules={[{ required: true, message: `Please select type ${index + 1}` }]}
                                                            label={`Select Type ${index + 1}`}
                                                        >
                                                            <Select showSearch 
                                                                onChange={() => {
                                                                    form.setFieldsValue({
                                                                        contact_detail: form.getFieldValue('contact_detail'),
                                                                    });
                                                                }} placeholder={`Select the CD type ${index + 1}`} filterOption={(input, option) => (option.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                                            >

                                                                <Option key="default" value={null}>
                                                                    ---- Select ----
                                                                </Option>

                                                                {CD_TYPE_SELECTION?.map((item) => (
                                                                    <Option key={item._id} value={item._id} label={item.name}>
                                                                        <span className="cap">{item.name}</span>
                                                                    </Option>
                                                                ))}

                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col span={20} xs={20} sm={20} md={6}> 
                                                        <Form.Item
                                                            className="qty-cls"
                                                            name={[field.name, 'label']}
                                                            rules={[{ required: true, message: `Please enter label ${index + 1}` }]}
                                                            label={`Label ${index + 1}`}
                                                        >
                                                            <Input autoComplete="off" placeholder={`Enter CD Label ${index + 1}`} />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col span={20} xs={20} sm={20} md={6}> 
                                                        <Form.Item
                                                            className="qty-cls"
                                                            name={[field.name, 'value']}
                                                            rules={[{ required: true, message: `Please enter value ${index + 1}` }]}
                                                            label={`Value ${index + 1}`}
                                                        >
                                                            <Input autoComplete="off" placeholder={`Enter CD Value ${index + 1}`} />
                                                        </Form.Item>
                                                    </Col>

                                                    {/* Show Hyperlink field only if 'type' is 'hyperlink' */}
                                                    {form.getFieldValue(['contact_detail', field.name, 'type']) === 'Hyperlink' && (
                    
                                                    <Col span={20} xs={20} sm={20} md={6}>
                                                        <Form.Item
                                                            className="qty-cls"
                                                            name={[field.name, 'hyperlink']}
                                                            rules={[{ required: true, message: `Please enter hyperlink ${index + 1}` }]}
                                                            label={`Hyperlink ${index + 1}`}
                                                        >
                                                            <Input autoComplete="off" placeholder={`Enter CD hyperlink ${index + 1}`} />
                                                        </Form.Item>
                                                    </Col>
                                                    
                                                    )}

                                                    <Col span={2} xs={2} sm={2} md={2}>
                                                        <div className="minus-wrap" style={{ marginTop: '20px' }}>
                                                            <MinusCircleOutlined onClick={() => remove(field.name)} style={{ borderRadius: '8px' }} />
                                                        </div>
                                                    </Col>

                                                </div>
                                            </Col>
                                        ))}
                                    </Row>

                                    <Col span={6}>
                                        <Form.Item className="mt-2" style={{ marginLeft: '-3px', width: '60%' }}>
                                            <Button onClick={() => add()} block icon={<PlusOutlined />}></Button>
                                        </Form.Item>
                                    </Col>
                                </>
                            )}
                        </Form.List>
                    </Col>

                    <Divider orientation="left" orientationMargin={15} className="devider-color">{"Product Services Section (PSS)"}</Divider>

                    <Col span={24} xs={24} sm={24} md={24}>
                        <h4> PSS Attributes (PSSA) </h4>

                        <div style={{ marginBottom : '13px' }}>
                            <Form.List name="common_psla">
                                {(commonPSLAFields, { add: addCommonPSLA, remove: removeCommonPSLA }) => (
                                    <>
                                        {commonPSLAFields.map((field, index) => (
                                            <Row gutter={16} key={field.key} style={{ marginBottom: '8px' }}>
                                                
                                                <Col span={8} xs={8} sm={8} md={8}>
                                                    <Form.Item
                                                        name={[field.name, 'psla_label']}
                                                        rules={[{ required: true, message: `Enter PSSA Label ${index + 1}` }]}
                                                        label={`PSSA Label ${index + 1}`}
                                                    >
                                                        <Input placeholder={`Enter PSSA Label ${index + 1}`} />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={8} xs={8} sm={8} md={8}>
                                                    <Form.Item
                                                        name={[field.name, 'psla_type']}
                                                        rules={[{ required: true, message: `Enter PSSA Type ${index + 1}` }]}
                                                        label={`PSSA Value Type ${index + 1}`}
                                                    >
                                                        <Select placeholder={`Select PSSA Value Type ${index + 1}`}>
                                                            
                                                            <Option key="default" value={null}>
                                                                ---- Select ----
                                                            </Option>

                                                            {PSLA_INPUT_TYPE?.map((item) => (
                                                                <Option key={item._id} value={item._id}>
                                                                    {item.name}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>

                                                <Col span={2} xs={2} sm={2} md={1}>
                                                    <MinusCircleOutlined onClick={() => removeCommonPSLA(field.name)} />
                                                </Col>
                                            </Row>
                                        ))}

                                        <Button type="dashed" onClick={() => addCommonPSLA()} block icon={<PlusOutlined />}>
                                            Add New PSSA
                                        </Button>
                                    </>
                                )}
                            </Form.List>
                        </div>

                        {/* PSL Section */}
                        <Form.List name="psl_list">
                            {(pslFields, { add: addPSL, remove: removePSL }) => (
                                <>
                                    {pslFields.map((pslField, pslIndex) => (
                                        <div key={pslField.key} style={{ marginBottom: '24px' }}>
                                           
                                            <Row gutter={16}>
                                                
                                                <Col span={8} xs={8} sm={8} md={8}>
                                                    <Form.Item
                                                        name={[pslField.name, 'psl_name']}
                                                        rules={[{ required: true, message: `Please enter PSL ${pslIndex + 1} name` }]}
                                                        label={`PSL Name ${pslIndex + 1}`}
                                                    >
                                                        <Input placeholder={`Enter PSL ${pslIndex + 1} Name`} />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={2} xs={2} sm={2} md={1}>
                                                    <MinusCircleOutlined onClick={() => removePSL(pslField.name)} />
                                                </Col>
                                            </Row>

                                            {/* Common PSLA for this PSL */}
                                            <div style={{ marginLeft: '20px' }}>

                                                <h5>Common PSLA for PSL {pslIndex + 1}</h5>
                                                
                                                <Form.List name={[pslField.name, 'common_psla_for_psl']}>
                                                    
                                                    {(commonPSLAFields, { add: addCommonPSLA, remove: removeCommonPSLA }) => (
                                                        <>
                                                            {commonPSLAFields.map((field, index) => (
                                                                <Row gutter={16} key={field.key} style={{ marginBottom: '8px' }}>

                                                                <Col span={8}>
                                                                    <Form.Item
                                                                        name={[field.name, 'psla_label']}
                                                                        rules={[{ required: true, message: `Enter Common PSLA Label ${index + 1}` }]}
                                                                        label={`Label ${index + 1}`}
                                                                    >
                                                                        <Input placeholder={`Enter Common PSLA Label ${index + 1}`} />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8}>
                                                                    <Form.Item
                                                                        name={[field.name, 'psla_type']}
                                                                        rules={[{ required: true, message: `Enter Common PSLA Value Type ${index + 1}` }]}
                                                                        label={`Value Type ${index + 1}`}
                                                                    >
                                                                        <Select placeholder={`Select Common PSLA Value Type ${index + 1}`}>
                                                                            <Option key="default" value={null}>
                                                                                ---- Select ----
                                                                            </Option>

                                                                            {PSLA_INPUT_TYPE?.map((item) => (
                                                                                <Option key={item._id} value={item._id}>
                                                                                    {item.name}
                                                                                </Option>
                                                                            ))}
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={2}>
                                                                    <MinusCircleOutlined onClick={() => removeCommonPSLA(field.name)} />
                                                                </Col>

                                                                </Row>
                                                            ))}
                                                            <Button
                                                                style={{ marginBottom: '13px' }}
                                                                type="dashed"
                                                                onClick={() => addCommonPSLA()}
                                                                block
                                                                icon={<PlusOutlined />}
                                                            >
                                                                Add Common PSLA for PSL {pslIndex + 1}
                                                            </Button>
                                                        </>
                                                    )}
                                                </Form.List>
                                            </div>

                                            {/* PS Section */}
                                            <div style={{ marginLeft: '20px' }}>

                                                <Form.List name={[pslField.name, 'ps_list']}>
                                                    {(psFields, { add: addPS, remove: removePS }) => (
                                                        <>
                                                            {psFields.map((psField, psIndex) => (
                                                                <div key={psField.key} style={{ marginBottom: '16px' }}>
                                                                    
                                                                    <Row gutter={16}>
                                                                        
                                                                        <Col span={8} xs={8} sm={8} md={8}>
                                                                            <Form.Item
                                                                                name={[psField.name, 'ps_name']}
                                                                                rules={[
                                                                                    { required: true, message: `Please enter PS ${psIndex + 1} for PSL ${pslIndex + 1}` },
                                                                                ]}
                                                                                label={`PS Name ${psIndex + 1} for PSL ${pslIndex + 1}`}
                                                                            >
                                                                                <Input placeholder={`Enter PS ${psIndex + 1} Name`} />
                                                                            </Form.Item>
                                                                        </Col>

                                                                        <Col span={2} xs={2} sm={2} md={1}>
                                                                            <MinusCircleOutlined onClick={() => removePS(psField.name)} />
                                                                        </Col>
                                                                    </Row>

                                                                    <div style={{ marginLeft: '20px' }}>

                                                                        <h5>PSLA for PS {psIndex + 1} (includes Common PSLA)</h5>
                                                                        
                                                                        <Form.List name={[psField.name, 'psla_list']}>
                                                                            {(pslaFields, { add: addPSLA, remove: removePSLA }) => (
                                                                                <>
                                                                                    {pslaFields.map((pslaField, pslaIndex) => (
                                                                                        <Row
                                                                                            gutter={16}
                                                                                            key={pslaField.key}
                                                                                        >

                                                                                            <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                                                                                                <Form.Item
                                                                                                    name={[pslaField.name, 'psla_required']}
                                                                                                    rules={[
                                                                                                        {
                                                                                                            required: true,
                                                                                                            message: `Select PSLA Required ${pslaIndex + 1} for PS ${psIndex + 1}`,
                                                                                                        },
                                                                                                    ]}
                                                                                                    label={`Mandatory ${pslaIndex + 1}`}
                                                                                                >

                                                                                                    <Select showSearch placeholder={`Select mandatory ${pslaIndex + 1}`} filterOption={(input, option) => (option.label ?? '').toLowerCase().includes(input.toLowerCase())}>

                                                                                                    <Option key="default" value={null}>
                                                                                                        ---- Select ----
                                                                                                    </Option>
                                                                                                    
                                                                                                    {PSLA_REQUIRED_SELECTION?.map((item) => (
                                                                                                        <Option key={item._id} value={item._id} label={item.name}>
                                                                                                            <span className="cap">{item.name}</span>
                                                                                                        </Option>
                                                                                                    ))}

                                                                                                    </Select>
                                                                                                </Form.Item>
                                                                                            </Col>

                                                                                            <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                                                                                                <Form.Item
                                                                                                    name={[pslaField.name, 'psla_display_summary']}
                                                                                                    rules={[
                                                                                                    {
                                                                                                        required: true,
                                                                                                        message: `Select PSLA display summary ${pslaIndex + 1} for PS ${psIndex + 1}`,
                                                                                                    },
                                                                                                    ]}
                                                                                                    label={`Display Summary ${pslaIndex + 1}`}
                                                                                                >
                                            
                                                                                                    <Select showSearch placeholder={`Display summary ${pslaIndex + 1}`} filterOption={(input, option) => (option.label ?? '').toLowerCase().includes(input.toLowerCase())}>
                                            
                                                                                                    <Option key="default" value={null}> ---- Select ---- </Option>
                                            
                                                                                                    {PSLA_REQUIRED_SELECTION?.map((item) => (
                                                                                                    <Option key={item._id} value={item._id} label={item.name}>
                                                                                                        <span className="cap">{item.name}</span>
                                                                                                    </Option>
                                                                                                    ))}
                                            
                                                                                                    </Select>
                                                                                                </Form.Item>
                                                                                            </Col>

                                                                                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                                                                                <Form.Item
                                                                                                    name={[pslaField.name, 'psla_label']}
                                                                                                    rules={[
                                                                                                        {
                                                                                                            required: true,
                                                                                                            message: `Enter PSLA Label ${pslaIndex + 1} for PS ${psIndex + 1}`,
                                                                                                        },
                                                                                                    ]}
                                                                                                    label={`Label ${pslaIndex + 1}`}
                                                                                                >
                                                                                                    <Input
                                                                                                        placeholder={`Enter PSLA Label ${pslaIndex + 1}`}
                                                                                                    />
                                                                                                </Form.Item>
                                                                                            </Col>

                                                                                            <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                                                                                                <Form.Item
                                                                                                    name={[pslaField.name, 'psla_type']}
                                                                                                    rules={[
                                                                                                        {
                                                                                                            required: true,
                                                                                                            message: `Enter PSLA Value Type ${pslaIndex + 1} for PS ${psIndex + 1}`,
                                                                                                        },
                                                                                                    ]}
                                                                                                    label={`Value Type ${pslaIndex + 1}`}
                                                                                                >


                                                                                                    <Select placeholder={`Select Value Type ${pslaIndex + 1}`}>
                                                                                                        
                                                                                                        <Option key="default" value={null}>
                                                                                                            ---- Select ----
                                                                                                        </Option>

                                                                                                        {PSLA_INPUT_TYPE?.map((item) => (
                                                                                                            <Option key={item._id} value={item._id}>
                                                                                                                {item.name}
                                                                                                            </Option>
                                                                                                        ))}
                                                                                                    </Select>
                                                                                                </Form.Item>
                                                                                            </Col>

                                                                                            <Col xs={4} sm={3} md={2} lg={2} xl={2}>
                                                                                                <MinusCircleOutlined onClick={() => removePSLA(pslaField.name)} />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    ))}
                                                                                    
                                                                                    <Button type="dashed" onClick={() => addPSLA()} block icon={<PlusOutlined />}>
                                                                                        Add Custom PSLA for PS {psIndex + 1}
                                                                                    </Button>
                                                                                </>
                                                                            )}
                                                                        </Form.List>

                                                                    </div>
                                                                </div>
                                                            ))}

                                                            <Button
                                                                type="dashed"
                                                                onClick={() => {
                                                                    const globalCommonPSLA = form.getFieldValue('common_psla') || [];
                                                                    const specificCommonPSLA = form.getFieldValue(['psl_list', pslField.name, 'common_psla_for_psl']) || [];
                                                                    
                                                                    addPS({
                                                                        ps_name: '',
                                                                        psla_list: [
                                                                            ...globalCommonPSLA.map((item) => ({ ...item })),
                                                                            ...specificCommonPSLA.map((item) => ({ ...item })),
                                                                        ],
                                                                    });
                                                                }}
                                                                block
                                                                icon={<PlusOutlined />}
                                                            >
                                                                Add New PS for PSL {pslIndex + 1}
                                                            </Button>
                                                        </>
                                                    )}
                                                </Form.List>

                                            </div>
                                        </div>
                                    ))}
                                    
                                    <Button textcolor="default" variant="text" onClick={() => addPSL()} block icon={<PlusOutlined />}>
                                        Add New PSL
                                    </Button>
                                </>
                            )}
                        </Form.List>
                    </Col>
                </Row>
                        
                <Form.Item className="btn-row float-right mt-3">
                    <Link className="ant-btn ant-btn-secondary" to={`/${routeName}${location.search}`}><i class="fas fa-arrow-left mr-5"></i> Back</Link>
                    <Button type="primary" loading={loading} htmlType="submit"><i class="fas fa-check mr-5"></i> Submit</Button>
                </Form.Item>
                </Form>
            </Spin>
        </Card>
    )
}

export default Add;
